import * as React from "react";

const TailLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={33} height={18} viewBox="0 0 33 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 0C4.71515 1.31559 9.09654 5.19389 12.8494 9.44425C16.9872 14.0994 23.8584 16.988 33 18V0H0Z" />
    </svg>
  );
};

export default TailLeft;
